export const baseUrl = {
  api: import.meta.env.VITE_APP_URL + '/api',
};

export const appName = import.meta.env.VITE_APP_NAME;
export const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

export const wsAdminId = import.meta.env.VITE_WEBSOCKET_ADMIN_ID;
export const wsUrl = import.meta.env.VITE_WEBSOCKET_URL;

export const pushVapidPublicKey = import.meta.env.VITE_VAPID_PUBLIC_KEY;
